
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9c579d33b40d9dfb$exports = {};

$parcel$export($9c579d33b40d9dfb$exports, "react-spectrum-ColorField-input", function () { return $9c579d33b40d9dfb$export$7d80c6630a750b1; }, function (v) { return $9c579d33b40d9dfb$export$7d80c6630a750b1 = v; });
var $9c579d33b40d9dfb$export$7d80c6630a750b1;
$9c579d33b40d9dfb$export$7d80c6630a750b1 = `Fm6LxG_react-spectrum-ColorField-input`;


export {$9c579d33b40d9dfb$exports as default};
//# sourceMappingURL=colorfield_css.mjs.map
